
import { prop, Vue } from "vue-class-component";
import { downloadFile } from "@/app/infrastructures/misc/Utils";
import { DownloadTemplateData } from "@/domain/entities/BulkBooking";
import { BulkDownloadController } from "@/app/ui/controllers/BulkDownloadController";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { downloadCsvFromCsvContent } from "@/app/infrastructures/misc/Utils";

class Props {
  title = prop<string>({
    default: ""
  });
  description = prop<string>({
    default: ""
  });
  dataComponent = prop<Array<DownloadTemplateData>>({
    default: []
  });
  typeDownload = prop<string>({
    default: ""
  });
}

export default class DownloadTemplateVertical extends Vue.with(Props) {
  onDownloadDocument(url: string, title: string) {
    downloadFile(url, title, `.xlsx`);
  }

  errorExport = false;
  async onDownloadCsv(title: string, type: string) {
    MainAppController.showLoading();

    const TIMEOUT_MS = 120000;
    const timeoutPromise = new Promise((_, reject) =>
      setTimeout(() => reject(new Error("Request timed out")), TIMEOUT_MS)
    );

    let resp: any = {
      success: false,
      data: ""
    };

    try {
      resp = await Promise.race([
        BulkDownloadController.getExistingData({
          service: "horde/v2",
          type: type
        }),
        timeoutPromise
      ]);

      this.errorExport = !resp.success;
      if (resp.success) {
        downloadCsvFromCsvContent({
          fileName: `${title}.csv`,
          csvContent: resp.data
        });
      }
    } catch (error) {
      console.error("Download CSV failed:", error);
      resp.success = false;
    }

    MainAppController.closeLoading();
  }
}
